import { Button } from "primereact/button";
import { useTranslation } from "@i18n/hooks";
import { type AnswerOptionV2Input } from "../../../__generated__/CreateMultipleChoiceElementButton_CreateMultipleChoiceElementV2Mutation.graphql";
import { htmlTagsInTextRemover } from "../../../util/htmlTagsInTextRemover";

type OwnProps = {
	answerOption: AnswerOptionV2Input;
	index: number;
	onDelete: () => void;
	onEdit: () => void;
};

export const AnswerOptionDisplay = ({ answerOption, index, onDelete, onEdit }: OwnProps) => {
	const { t } = useTranslation("common");
	return (
		<div key={`${answerOption.answer}-${index}`} className="grid">
			<div className="col-10">
				<div>
					{t("forms.answer")}: {htmlTagsInTextRemover(answerOption.answer)}
				</div>
				{answerOption.imageRef
					? t("educationalOffer.withImage")
					: t("educationalOffer.withoutImage")}{" "}
				|{" "}
				{answerOption.isCorrect
					? t("educationalOffer.correctSelection")
					: t("educationalOffer.isWrong")}
			</div>
			<div className="flex col-2 justify-content-end">
				<div>
					<Button className="ml-2" icon="pi pi-pencil" type="button" onClick={onEdit} />
					<Button className="ml-2" icon="pi pi-trash" type="button" onClick={onDelete} />
				</div>
			</div>
		</div>
	);
};
